import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import cubaimg from "../../assets/logo/coppe-black.png"
import CustomizerContext from '../../_helper/Customizer';

const SidebarIcon = () => {
  const { layoutURL } = useContext(CustomizerContext);
  return (
    <div className="logo-icon-wrapper">
      <Link to={`${process.env.PUBLIC_URL}/presentation/eor/wag/${layoutURL}`}>
        <img
          width={35}
          height={35}
          className="img-fluid"
          src={cubaimg}
          alt=""
        />
      </Link>
    </div>
  );
};

export default SidebarIcon;